// extracted by mini-css-extract-plugin
export default {"ExecutiveSummary":"executiveSummary_ExecutiveSummary__Qk8bW","ExecutiveSummaryTotal":"executiveSummary_ExecutiveSummaryTotal__v+zvm"};